import Http from '@core/plugins/http';
import { apiMng, apiAero, apiAds, apiVideo } from '~/constants/apiUrls';
import {
  getAccessToken,
  setAccessToken,
  resetAccessToken,
  resetAccountInfo
} from '@core/utils/authService';
import { useRequestsDispatcherStore } from '~/stores/requestsDispatcher';

const handleUnauthorized = () => {
  resetAccessToken();
  resetAccountInfo();

  if (process.env.NODE_ENV === 'production') {
    const currentLocation = document.location.href;

    if (currentLocation && !currentLocation.includes('#/login')) {
      document.location.replace(`${currentLocation.split('#')[0]}#/login`);
    }
  }
};

const createHttpClient = (baseURL: string): Http =>
  new Http({
    baseURL,
    getToken: () => getAccessToken(),
    onTokenUpdate: (token) => {
      setAccessToken(token);
    },
    onUnauthorized: handleUnauthorized
  });

const createAdsHttpClient = (baseURL: string, token?: string): Http =>
  new Http({
    baseURL,
    token,
    onTokenUpdate: async (newToken, response) => {
      const requestsDispatcherStore = useRequestsDispatcherStore();
      const requestUrl = (response.config.url || '').replace(/^\//, '');
      const baseForAuth = requestUrl.split('/')[0];

      // если нужно обновлять userData/acx через повторную авторизацию в базу
      await requestsDispatcherStore.authToBase(baseForAuth);

      // если новый токен тоже нужно держать прямо в инстансе — он уже setAuthToken-нут внутри Http
      // при желании можно дополнительно обновить store.userData вручную
    },
    
    onUnauthorized: async () => {
      const requestsDispatcherStore = useRequestsDispatcherStore();
      const base = requestsDispatcherStore.userData?.baseName;

      if (base) {
        await requestsDispatcherStore.authToBase(base);
      }
    }
  });

const createAdsAuthHttpClient = (baseURL: string): Http =>
  new Http({
    baseURL,
    getToken: () => getAccessToken(),
    onTokenUpdate: (token) => {
      setAccessToken(token);
    },
    onUnauthorized: handleUnauthorized
  });

export const apiMngClient = createHttpClient(apiMng);
export const apiAeroClient = createHttpClient(apiAero);
export const apiAdsAuthClient = createAdsAuthHttpClient(apiAds);
export const apiAdsClient = (token?: string) => createAdsHttpClient(apiAds, token);
export const apiVideoClient = createAdsAuthHttpClient(apiVideo);